module.exports = __webpack_public_path__ + "img/discord.62ccf9b5.png";